import { Numeric } from '../../atoms/numeric'
import { Percent } from '../../atoms/percent'
import { StyledDetailedAssetTable } from './primitives'

type Asset = {
  fixedMultiplier?: number
  id: string
  investment?: number
  maxLevRatio: number
  name: string
  return: number
  volatility: number
  weight?: number
}

export type DetailedAssetTableProps = {
  assets?: Asset[]
  isFundOfFunds: boolean
}

export function DetailedAssetTable({ assets, isFundOfFunds }: DetailedAssetTableProps) {
  return (
    <StyledDetailedAssetTable>
      <thead>
        <tr>
          <th className="asset">Asset</th>
          <th className="max-lev-ratio">Max Lev Ratio</th>
          <th className="multiplier">Multiplier</th>
          <th className="return">Return</th>
          <th className="volatility">Volatility</th>
          <th className="weight">{isFundOfFunds ? 'Target (%)' : 'Weight (%)'}</th>
          {isFundOfFunds && <th className="investment">Investment (%)</th>}
        </tr>
      </thead>
      <tbody>
        {Array.isArray(assets) &&
          assets.map(asset => (
            <tr key={asset.name}>
              <td className="asset">{asset.name}</td>
              <td className="max-lev-ratio">
                <Numeric value={asset.maxLevRatio} />
              </td>
              <td className="multiplier">
                <Numeric value={asset.fixedMultiplier} />
              </td>
              <td className="return">
                <Percent
                  fixed
                  highlightPnl
                  numDecimalPlaces={2}
                  value={asset.return === null ? null : asset.return * 100}
                />
              </td>
              <td className="volatility">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={asset.volatility === null ? null : asset.volatility * 100}
                />
              </td>
              <td className="weight">
                <Percent
                  fixed
                  highlightPnl={false}
                  numDecimalPlaces={2}
                  value={asset.weight * 100}
                />
              </td>
              {asset.investment && (
                <td className="investment">
                  <Percent
                    fixed
                    highlightPnl={false}
                    numDecimalPlaces={2}
                    value={asset.investment * 100}
                  />
                </td>
              )}
            </tr>
          ))}
      </tbody>
    </StyledDetailedAssetTable>
  )
}
